import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export const memoSummarySearchScheme = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  response: z.string().optional(),
});

export type MemoSummarySearchSchemeType = z.infer<typeof memoSummarySearchScheme>;

export const getDefaultMemoSummarySearchFields = (
  arg?: Partial<MemoSummarySearchSchemeType>,
): MemoSummarySearchSchemeType => ({
  startDate: undefined,
  endDate: undefined,
  response: '',
  ...arg,
});

export const useMemoSummarySearchForm = ({
  defaultValues,
}: {
  defaultValues: MemoSummarySearchSchemeType;
}) => {
  return useForm<MemoSummarySearchSchemeType>({
    resolver: zodResolver(memoSummarySearchScheme),
    mode: 'onChange',
    defaultValues,
  });
};

export const useMemoSummarySearchFormContext = () => {
  return useFormContext<MemoSummarySearchSchemeType>();
};
